export default "__VITE_ASSET__B03mPnUN__"